import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './context/AuthContext'
import ErrorBoundary from './components/common/ErrorBoundary'
import AppRoutes from './utils/routes'
import ChatbotWidget from './components/chat/ChatbotWidget'
import SEO from './components/seo/SEO'
import { generateWebsiteStructuredData, generateOrganizationStructuredData } from './utils/seo'
import './styles/variables.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

function App() {
  const siteUrl = 'https://3afer.net'
  const websiteStructuredData = generateWebsiteStructuredData(siteUrl)
  const organizationStructuredData = generateOrganizationStructuredData(siteUrl)

  return (
    <ErrorBoundary>
      <HelmetProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            {/* Global SEO - Website and Organization structured data */}
            <SEO 
              structuredData={[websiteStructuredData, organizationStructuredData]}
            />
            <AuthProvider>
              <AppRoutes />
              <ChatbotWidget />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </HelmetProvider>
    </ErrorBoundary>
  )
}

export default App
